/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useEffect } from "react";
import { useAppRollenContext } from "../../Components/AppRollenContext";
import { environment } from "../../environment";

export interface PortalPrueferProps {
    children: React.ReactNode;
}

export default function PortalPruefer(props: PortalPrueferProps) {
    const rollenContext = useAppRollenContext();
    const { loading, istNutzend } = rollenContext;

    const url = window.location.pathname;

    useEffect(() => {
        if (url && !loading && !environment.isSystem) {
            const istBuchungsportal = environment.istBuchungsportal;
            if (!istBuchungsportal) {
                if (!istNutzend) {
                    window.location.replace(`${environment.mandantUrl}/buchungsportal/`);
                }
            }
        }
    }, [url, loading, istNutzend]);

    return <>{props.children}</>;
}
